import { makeRequest } from "./client";
import type { NovaSuggestionsRequest, NovaSuggestionsResult } from "../../domain/nova/novaReview";
import type { NovaConfirmRequest, NovaConfirmResult } from "../../domain/nova/novaConfirm";

/** Nova: only reachable when the Organization has the `nova` flag on. */
export const novaApi = {
  /** Reads a typed update and returns Suggestions. Nothing is written to Notices. */
  getSuggestions: async (
    orgId: string,
    request: NovaSuggestionsRequest,
    token: string,
  ): Promise<NovaSuggestionsResult> =>
    makeRequest<NovaSuggestionsResult>(`/v1/org/${encodeURIComponent(orgId)}/nova/suggestions`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(request),
    }),

  /** Turns confirmed Suggestions into Drafts marked "Drafted by Nova". Never publishes. */
  confirm: async (orgId: string, request: NovaConfirmRequest, token: string): Promise<NovaConfirmResult> =>
    makeRequest<NovaConfirmResult>(`/v1/org/${encodeURIComponent(orgId)}/nova/confirm`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(request),
    }),
};
